import React from "react";
import "./index.css";
import AddEffortButton from "../components/ActionPlans/AddEffortButton";

const GridLayout = ({
  items,
  renderItem,
  containerClassName = "",
  itemClassName = "",
  className,
  newName,
  setNewName,
  handleSave,
}) => {
  const allItems = [...items];
  if (className) {
    allItems.push({ isAddButton: true });
  }

  return (
    <div className={`grid-wrapper ${containerClassName}`}>
      <div className="grid-container">
        <div className="grid-layout">
          {chunk(allItems, 3).map((row, rowIndex) => (
            <div key={`row-${rowIndex}`} className="grid-row">
              {row.map((item, itemIndex) => (
                <div
                  key={`item-${rowIndex}-${itemIndex}`}
                  className={`grid-item ${itemClassName}`}
                >
                  {item.isAddButton ? (
                    <AddEffortButton
                      className={className}
                      newName={newName}
                      setNewName={setNewName}
                      handleSave={handleSave}
                    />
                  ) : renderItem ? (
                    renderItem(item)
                  ) : (
                    <div className="default-item">
                      <h4>{item.name}</h4>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  );

export default GridLayout;
